import type { AgentType, AssistantConfig } from '@ardoq/api-types';
import {
  type FeatureContext,
  featureOperations,
  Features,
} from '@ardoq/features';

export const getHasAssistantConfigFeature = (
  featureContext: FeatureContext
): boolean =>
  featureOperations.hasFeature(
    featureContext,
    Features.AI_INTERNAL_ASSISTANT_CONFIG
  );

export const getAssistantConfigToSend = (
  featureContext: FeatureContext,
  agentType: AgentType | undefined,
  assistantConfig: AssistantConfig
): AssistantConfig | undefined => {
  if (agentType) return undefined;
  if (!getHasAssistantConfigFeature(featureContext)) return undefined;
  return assistantConfig;
};
